export default {"src":"/_next/static/media/face-shield.d4da5d7c.svg","height":187,"width":148,"blurWidth":0,"blurHeight":0};